import React from 'react';

import OutfitMedium from 'styles/fonts/outfit/Outfit-Medium.woff2';
import OutfitBold from 'styles/fonts/outfit/Outfit-Bold.woff2';
import OutfitRegular from 'styles/fonts/outfit/Outfit-Regular.woff2';
import OutfitSemiBold from 'styles/fonts/outfit/Outfit-SemiBold.woff2';
import InterBold from 'styles/fonts/inter/Inter-Bold.woff2';
import InterItalic from 'styles/fonts/inter/Inter-Italic.woff2';
import InterRegular from 'styles/fonts/inter/Inter-Regular.woff2';
import InterSemiBold from 'styles/fonts/inter/Inter-SemiBold.woff2';

export const PreloadEssentials = () => {
  return (
    <>
      <link rel="prefetch" as="font" crossOrigin="anonymous" href={OutfitMedium} type="font/woff2" />
      <link rel="prefetch" as="font" crossOrigin="anonymous" href={OutfitBold} type="font/woff2" />
      <link rel="prefetch" as="font" crossOrigin="anonymous" href={OutfitRegular} type="font/woff2" />
      <link rel="prefetch" as="font" crossOrigin="anonymous" href={OutfitSemiBold} type="font/woff2" />
      <link rel="prefetch" as="font" crossOrigin="anonymous" href={InterBold} type="font/woff2" />
      <link rel="prefetch" as="font" crossOrigin="anonymous" href={InterItalic} type="font/woff2" />
      <link rel="prefetch" as="font" crossOrigin="anonymous" href={InterRegular} type="font/woff2" />
      <link rel="prefetch" as="font" crossOrigin="anonymous" href={InterSemiBold} type="font/woff2" />
    </>
  );
};
